import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostAdvertise = (bannerImgState, mainImgState, urlRef) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("POST", `/admin/advertise`, {
            "banner_img": bannerImgState,
            "img_list": mainImgState,
            "url": urlRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate("/ad")
                break
            case 400:
                if (fetchResult?.data?.error_code === "banner_img") setAlert("배너 이미지를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "img_list") setAlert("본문 이미지를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePostAdvertise